$(document).ready(() => {
  // otevreni a vycentrovani noveho pop-up okna
  function openFormInPopUp(url, name, w, h) {
    var dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : screen.left
    var dualScreenTop = window.screenTop !== undefined ? window.screenTop : screen.top

    var width,
        height
    width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width
    height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height

    var left = ((width / 2) - (w / 2)) + dualScreenLeft
    var top = ((height / 2) - (h / 2)) + dualScreenTop
    var newWindow = window.open(url, name, 'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left)
  }

  $('#pojisteni-popup-form').on('click', function(e) {
    e.preventDefault()
    openFormInPopUp('http://allianz.studentagency.cz/form.php', 'formPopUpInsurance', 615, 630);
  })
})



/** WEBPACK FOOTER **
 ** c:/Users/martin.nikl/Desktop/SA GITLAB/frontend/sites/letenky.cz/src/js/subpages/insurance.js
 **/